import { render } from "./ProposalClientList.vue?vue&type=template&id=64ad824a&scoped=true"
import script from "./ProposalClientList.vue?vue&type=script&lang=ts"
export * from "./ProposalClientList.vue?vue&type=script&lang=ts"

import "./ProposalClientList.vue?vue&type=style&index=0&id=64ad824a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-64ad824a"

export default script